import { VueStorefrontModule } from '@vue-storefront/core/lib/module'
import { Catalog } from '@vue-storefront/core/modules/catalog'
import { Cart } from '@vue-storefront/core/modules/cart'
import { Checkout } from '@vue-storefront/core/modules/checkout'
import { Compare } from '@vue-storefront/core/modules/compare'
import { Review } from '@vue-storefront/core/modules/review'
import { Mailer } from '@vue-storefront/core/modules/mailer'
import { Wishlist } from '@vue-storefront/core/modules/wishlist'
import { Newsletter } from '@vue-storefront/core/modules/newsletter'
import { Notification } from '@vue-storefront/core/modules/notification'
import { RecentlyViewed } from '@vue-storefront/core/modules/recently-viewed'
import { Url } from '@vue-storefront/core/modules/url'
import { Homepage } from './homepage'
import { Claims } from './claims'
import { PromotedOffers } from './promoted-offers'
import { Ui } from './ui-store'
import { GoogleTagManager } from './google-tag-manager'
import { Hotjar } from './hotjar';
import { PaymentBackendMethods } from './payment-backend-methods';
import { CustomPayments } from './custom-payments';
import { RawOutputExample } from './raw-output-example'
import { OrderHistory } from './order-history'
import { ProductsCategories } from './products_categories'
import { PickupCheckout } from "./pickup-checkout";
import { Locations } from './locations'
import { Partners } from './partners'
import { Configs } from './configs'
import { Languages } from './languages'
import { Vacancies } from "./vacancies"

import { isServer } from '@vue-storefront/core/helpers'
import { FacebookPixel } from './facebook-pixel'
import { IPayPayment } from './ipay-payment'
import { SocialLogin } from './social-login'
import { Transport } from './transport'
// import { Example } from './module-template'

// This is how you can extend any of VS modues
// const extendCartVuex = {
//   actions: {
//     load () {
//       Logger.info('New load function')()
//     }
//   }
//  }

//  const cartExtend = {
//   key: 'cart',
//   afterRegistration: function(isServer, config) {
//     Logger.info('New afterRegistration hook')()
//   },
//   store: { modules: [{ key: 'cart', module: extendCartVuex }] },
//  }

//  extendModule(cartExtend)

// import { layeredNavigationModule } from './layered-navigation'
// extendModule(layeredNavigationModule)

declare global {
  interface Window { hj: any }
}

if (!isServer) {
  window.hj = window.hj || {};
}

/**
 * Some of the modules are registered lazily only when components from the module are appearing on current page.
 * If you want to use this module in pages without its components you need to remember about registering module first
 * In VS 1.8 this modules will be seamlessly lazyLoaded after proper action dispatch
 * - Wishlist
 */
export const registerModules: VueStorefrontModule[] = [
  Checkout,
  Catalog,
  Cart,
  Compare,
  Configs,
  FacebookPixel,
  Review,
  Mailer,
  Wishlist,
  Newsletter,
  Notification,
  Ui,
  RecentlyViewed,
  Homepage,
  Claims,
  PromotedOffers,
  GoogleTagManager,
  Hotjar,
  PaymentBackendMethods,
  CustomPayments,
  Locations,
  Partners,
  RawOutputExample,
  PickupCheckout,
  Url,
  OrderHistory,
  ProductsCategories,
  IPayPayment,
  SocialLogin,
  Languages,
  Vacancies,
  Transport
]
